import { BaseModel } from '../../_base/crud';
import { DrugGroup } from './drug-group.model';

export class Drug extends BaseModel {
  id: number;
  drug: string;
  strength: number;
  unit: string;
  ndc: string;
  brand_generic_flag: boolean;
  brand: string;
  generic: string;
  th_class: string;
  cfi: string;
  drug_schedule: number;
  otc_flag: boolean;
  upc_code: string;
  processed: boolean;
  hicl_seqno: string;
  pack_size: string;
  jcode: string;
  gpi: string;
  ddid: string;
  note: string;
  is_active: boolean;
  drug_group: DrugGroup;
  manufacturer;
  form;
  rxcui;
  ln60: any;
  avatar;
  pre_signed_url;
  changeActiveStatus() {
    this.is_active = !this.is_active;
  }
}
